import { render, staticRenderFns } from "./PNGTabs.vue?vue&type=template&id=3f251e24"
import script from "./PNGTabs.vue?vue&type=script&lang=js"
export * from "./PNGTabs.vue?vue&type=script&lang=js"
import style0 from "./PNGTabs.vue?vue&type=style&index=0&id=3f251e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports